import SidebarBookingsSummaryModifyController from 'uplisting-frontend/pods/-sidebar/bookings/summary/modify/controller';

export default class ProtectionOverviewBookingsSummaryModifyController extends SidebarBookingsSummaryModifyController {}
